"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FEATURE_FLAGS_DEV = void 0;
var FEATURE_FLAGS_DEV = JSON.parse(process.env.REACT_APP_FEATURE_FLAGS_DEV || null);
exports.FEATURE_FLAGS_DEV = FEATURE_FLAGS_DEV;